import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Modal from './Modal/Modal';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  primaryButtonText?: React.ReactNode;
  secondaryButtonText?: React.ReactNode;
  onPrimaryAction: () => void;
  onSecondaryAction?: () => void;
  onClose: () => void;
  width?: 'sm' | 'md' | 'lg' | 'xl' | string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl';
  outerPadding?: number;
  primaryButtonDisabled?: boolean;
  secondaryButtonDisabled?: boolean;
  height?: 'sm' | 'md' | 'lg' | 'xl';
  sx?: object;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  description,
  primaryButtonText = 'Confirm',
  secondaryButtonText = 'Cancel',
  onPrimaryAction,
  onSecondaryAction,
  onClose,
  width = 'md',
  maxWidth = 'md',
  outerPadding = 0,
  primaryButtonDisabled = false,
  secondaryButtonDisabled = false,
  height = 'md',
  sx = {},
}) => {
  const handleSecondaryAction = () => {
    onSecondaryAction?.() ?? onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth={maxWidth}
      width={width}
      outerPadding={outerPadding}
      height={height}
      sx={sx}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: 120,
        }}
      >
        {description && (
          <Box sx={{ px: 0, py: 3, flex: 1 }}>
            <Typography variant="body1" color="text.secondary">
              {description}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
            px: '13px',
            borderTop: '1px solid',
            borderColor: 'divider',
            pt: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleSecondaryAction}
            sx={{
              textTransform: 'none',
              minWidth: 80,
              fontWeight: 400,
              fontSize: 14,
              backgroundColor: '#EEF5FF',
              color: 'primary.main',
            }}
            disabled={secondaryButtonDisabled}
          >
            {secondaryButtonText}
          </Button>

          <Button
            variant="contained"
            onClick={onPrimaryAction}
            sx={{
              textTransform: 'none',
              minWidth: 80,
              fontWeight: 400,
              fontSize: 14,
            }}
            disabled={primaryButtonDisabled}
          >
            {primaryButtonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
